module.exports = __webpack_public_path__ + "static/finance-4f274a1e3d4bcb6a65dad3f376c5e3fa.jpg";